import Success from '../../pages/PayBills/Success';
import React, { useState } from 'react';

function AirtimeSuccessContainer({ closeModal }) {
	return (
		<div>
			<Success closeModal={closeModal} />
		</div>
	);
}

export default AirtimeSuccessContainer;
